(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-assets"] && !Shopify.designMode) return;
  try {
    /* ==========================================================================
   Bharat Protein Mahotsav — landing page behaviour
   Reads campaign config from #pm-config (output by the "Mahotsav · Campaign
   settings" section) and talks to the real Shopify cart (/cart/*.js).
   ========================================================================== */
(function () {
  'use strict';

  var PM = (window.PM = window.PM || {});
  var C = { tiers: [] };
  var cart = null;
  var payment = 'prepaid';
  var prevGiftCount = null;
  var lastFocus = null;
  var toastTimer = null;

  try { payment = localStorage.getItem('pm-pay') || 'prepaid'; } catch (e) {}

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function track(ev, data) {
    var o = { event: 'mahotsav_' + ev };
    for (var k in data || {}) o[k] = data[k];
    (window.dataLayer = window.dataLayer || []).push(o);
  }
  function rs(rupees) { return (C.sym || '₹') + Math.round(rupees).toLocaleString('en-IN'); }
  function rsP(paise) { return rs(paise / 100); }
  function plural(n, one, many) { return n === 1 ? one : many; }

  /* ---------- config + campaign state ---------- */
  /* Used when the Campaign section isn't on the page (e.g. theme-editor previews). */
  var DEFAULTS = {
    mode: 'live', start: '2026-10-21T00:00:00+05:30', end: '2026-11-11T23:59:59+05:30',
    gold: true, goldMin: 8000, basis: 'final', eligibleOnly: false,
    footnote: 'Gifts are cumulative · calculated on eligible subtotal after discounts, excl. shipping',
    prepaidType: 'fixed', prepaidValue: 200, preBtn: 'Available 21 Oct',
    interceptHeader: false, cartMode: 'gokwik', cartUrl: '/cart', root: '/', sym: '₹',
    tiers: [
      { at: 2000, name: 'Plastic Shaker', short: 'Plastic Shaker' },
      { at: 4000, name: 'Creatine', short: 'Creatine', flag: 'Creatine tier' },
      { at: 6000, name: 'Metal Shaker', short: 'Metal Shaker' },
      { at: 8000, name: 'Pre-Workout', short: 'Pre-Workout', flag: '4-gift tier' },
      { at: 10000, name: '500g Whey Concentrate', short: '500g Whey' }
    ]
  };

  function readConfig() {
    var el = document.getElementById('pm-config');
    if (el) {
      try { C = JSON.parse(el.textContent); } catch (e) { C = JSON.parse(JSON.stringify(DEFAULTS)); }
    } else {
      C = JSON.parse(JSON.stringify(DEFAULTS));
    }
    // Gift meter section can supply its own gifts + texts; they apply page-wide.
    C.texts = {};
    var mcs = $$('[data-pm-meter-config]'), mc = null;
    for (var mi = 0; mi < mcs.length; mi++) {
      try { var tmp = JSON.parse(mcs[mi].textContent); if (!mc || (tmp.tiers && tmp.tiers.length)) { mc = mcs[mi]; if (tmp.tiers && tmp.tiers.length) break; } } catch (e) {}
    }
    if (mc) {
      try {
        var mcfg = JSON.parse(mc.textContent);
        if (mcfg.tiers && mcfg.tiers.length) C.tiers = mcfg.tiers;
        C.texts = mcfg.texts || {};
        if (mcfg.footnote) C.footnote = mcfg.footnote;
        C.meterThumbs = mcfg.thumbs !== false;
        C.thumbShape = mcfg.shape || 'square';
      } catch (e) {}
    }
    C.tiers = (C.tiers || []).filter(function (t) { return t.at > 0; }).sort(function (a, b) { return a.at - b.at; });
    C.startD = new Date(C.start);
    C.endD = new Date(C.end);
    C.max = C.tiers.length ? C.tiers[C.tiers.length - 1].at : 1;
    return true;
  }

  function campaignState() {
    if (C.mode && C.mode !== 'auto') return C.mode;
    var n = new Date();
    if (!isNaN(C.startD) && n < C.startD) return 'pre';
    if (!isNaN(C.endD) && n > C.endD) return 'ended';
    return 'live';
  }

  function applyState() {
    var d = document.documentElement;
    var st = campaignState();
    var changed = d.getAttribute('data-pm-state') !== st;
    if (changed) {
      d.classList.remove('pm-s-pre', 'pm-s-live', 'pm-s-ended');
      d.classList.add('pm-s-' + st);
      d.setAttribute('data-pm-state', st);
    }
    d.classList.add('pm-page');
    d.classList.toggle('pm-gold-on', !!C.gold);
    d.classList.toggle('pm-no-gold', !C.gold);
    d.classList.toggle('pm-theme-b', C.theme === 'b');
    PM.state = st;
    return changed;
  }

  /* ---------- pricing + gifts ---------- */
  function hasPrepaid() { return C.prepaidType !== 'none' && C.prepaidValue > 0; }
  function prepaidOff(unitPaise) {
    if (!unitPaise) return 0;
    if (C.prepaidType === 'fixed') return Math.min(unitPaise, Math.round(C.prepaidValue * 100));
    if (C.prepaidType === 'percent') return Math.round(unitPaise * C.prepaidValue / 100);
    return 0;
  }
  function gifts(sub) {
    var unlocked = C.tiers.filter(function (t) { return sub >= t.at; });
    var next = C.tiers[unlocked.length] || null;
    return { unlocked: unlocked, count: unlocked.length, next: next, remaining: next ? next.at - sub : 0, total: C.tiers.length };
  }
  function eligibleIds() {
    var ids = {};
    $$('[data-pm-pid]').forEach(function (el) { ids[el.getAttribute('data-pm-pid')] = true; });
    (C.eligibleIds || []).forEach(function (id) { ids[id] = true; });
    return ids;
  }

  /* Totals in rupees. m = Mahotsav (what Shopify charges), p = prepaid estimate. */
  function sums() {
    var r = { m: 0, p: 0, em: 0, ep: 0, count: 0 };
    if (!cart) return r;
    var ids = C.eligibleOnly ? eligibleIds() : null;
    cart.items.forEach(function (it) {
      var line = it.final_line_price;
      var off = hasPrepaid() && line > 0 ? prepaidOff(it.final_price) * it.quantity : 0;
      r.m += line; r.p += line - off; r.count += it.quantity;
      if (!ids || ids[it.product_id]) { r.em += line; r.ep += line - off; }
    });
    var cartDisc = Math.max(0, (cart.items_subtotal_price || 0) - (cart.total_price || 0));
    r.m = Math.max(0, r.m - cartDisc); r.p = Math.max(0, r.p - cartDisc);
    r.em = Math.max(0, r.em - cartDisc); r.ep = Math.max(0, r.ep - cartDisc);
    ['m', 'p', 'em', 'ep'].forEach(function (k) { r[k] = r[k] / 100; });
    return r;
  }
  function eligibleFrom(s, pay) {
    var usePrepaid = C.basis === 'final' && hasPrepaid() && (pay || payment) === 'prepaid';
    return usePrepaid ? s.ep : s.em;
  }

  /* ---------- gift progress ---------- */
  function tierState(t, eligible, g) {
    return eligible >= t.at ? 'done' : g.next && g.next.at === t.at ? 'next' : 'locked';
  }
  /* Fill a merchant message: [amount] [gift] [count] [total], [b]bold[/b]. */
  function fillMsg(tpl, vars) {
    var out = esc(tpl);
    out = out.replace(/\[b\]/g, '<b>').replace(/\[\/b\]/g, '</b>');
    return out.replace(/\[(amount|gift|count|total)\]/g, function (_, k) { return esc(vars[k] == null ? '' : vars[k]); });
  }
  function giftThumb(t, st, xs) {
    var cls = 'pm-gthumb pm-' + st + (xs ? ' pm-xs' : '') + (t.img ? ' pm-has-img' : '') + (C.thumbShape === 'circle' ? ' pm-round' : '');
    var inner = t.img ? '<img src="' + esc(t.img) + '" alt="" loading="lazy" width="84" height="84">' : '<span>' + esc(t.short || t.name) + '</span>';
    return '<span class="' + cls + '" title="' + esc(t.name) + '">' + inner + '</span>';
  }
  function progressHTML(eligible, compact) {
    if (!C.tiers.length) return '';
    var g = gifts(eligible);
    var pct = Math.min(100, (eligible / C.max) * 100);
    var T = C.texts || {};
    var vars = { count: g.count, total: g.total, gift: g.next ? g.next.name : '', amount: g.next ? rs(eligible <= 0 ? g.next.at : g.remaining) : '' };
    var msg;
    if (!g.next) msg = fillMsg(T.done || '[b]All [total] free gifts unlocked.[/b] Every Mahotsav gift is yours.', vars);
    else if (eligible <= 0) msg = fillMsg(T.empty || 'Add [amount] of eligible products to unlock a [b]FREE [gift][/b]', vars);
    else msg = fillMsg(T.progress || "You're just [b][amount][/b] away from unlocking [b]FREE [gift][/b]!", vars);
    var countLbl = fillMsg(T.count || '[count]/[total] gifts', vars);
    var h = '<div class="pm-gp' + (compact ? ' pm-compact' : '') + '">';
    h += '<div class="pm-gp-top"><p class="pm-gp-msg">' + msg + '</p><span class="pm-gp-count pm-mono">' + countLbl + '</span></div>';
    h += '<div class="pm-gp-track" role="progressbar" aria-valuemin="0" aria-valuemax="' + C.max + '" aria-valuenow="' + Math.round(eligible) + '" aria-label="Gift progress">';
    h += '<div class="pm-gp-fill" style="width:' + pct + '%"></div>';
    C.tiers.forEach(function (t) {
      var s = tierState(t, eligible, g);
      h += '<span class="pm-gp-node pm-' + s + '" style="left:' + Math.min(100, (t.at / C.max) * 100) + '%"><i>' + (s === 'done' ? '✓' : '') + '</i></span>';
    });
    h += '</div><div class="pm-gp-labels" style="--pm-n:' + g.total + '">';
    C.tiers.forEach(function (t) {
      var s = tierState(t, eligible, g);
      h += '<div class="pm-gp-lab pm-' + s + '">' + (compact || C.meterThumbs === false ? '' : giftThumb(t, s)) + '<b>' + rs(t.at) + '</b><span>' + esc(t.short || t.name) + '</span></div>';
    });
    h += '</div>';
    if (!compact && (C.footnote || (C.gold && eligible >= C.goldMin))) {
      h += '<p class="pm-gp-foot pm-mono">' + esc(C.footnote || '') + (C.gold && eligible >= C.goldMin ? ' · ' + esc(T.gold || 'Gold draw: eligible (separate promotion)') : '') + '</p>';
    }
    return h + '</div>';
  }

  /* ---------- ladder ---------- */
  function renderLadder(eligible) {
    $$('[data-pm-ladder]').forEach(function (ol) {
      var g = gifts(eligible);
      var live = PM.state === 'live';
      ol.style.setProperty('--pm-n', C.tiers.length);
      var h = '';
      C.tiers.forEach(function (t, i) {
        var s = tierState(t, eligible, g);
        var key = !!t.flag;
        h += '<li class="pm-step pm-' + s + (key ? ' pm-key' : '') + '">';
        h += '<div class="pm-step-rail" aria-hidden="true"><span class="pm-step-dot">' + (s === 'done' ? '✓' : i + 1) + '</span></div>';
        h += '<div class="pm-step-card">';
        if (key) h += '<span class="pm-step-flag pm-mono">' + esc(t.flag) + '</span>';
        h += '<div class="pm-step-img">' + (t.imgL ? '<img src="' + esc(t.imgL) + '" alt="' + esc(t.name) + '" loading="lazy" width="300" height="300">' : '<div class="pm-ph">' + esc(t.name) + '</div>') + '</div>';
        h += '<div class="pm-step-txt"><span class="pm-step-at">' + rs(t.at) + '+</span><b>Free ' + esc(t.name) + '</b>';
        h += '<div class="pm-step-total"><span class="pm-pips" aria-hidden="true">';
        C.tiers.forEach(function (_, j) { h += '<i class="' + (j <= i ? 'pm-on' : '') + '"></i>'; });
        h += '</span><span class="pm-mono">' + (i + 1) + ' ' + plural(i + 1, 'gift', 'gifts') + ' total</span></div>';
        if (i > 0) h += '<small>Includes ' + C.tiers.slice(0, i).map(function (x) { return esc(x.short || x.name); }).join(', ') + '</small>';
        if (live) h += '<span class="pm-step-state pm-mono pm-' + s + '">' + (s === 'done' ? 'Unlocked in your cart' : s === 'next' ? rs(t.at - eligible) + ' to go' : 'Locked') + '</span>';
        h += '</div></div></li>';
      });
      ol.innerHTML = h;
    });
  }

  /* ---------- drawer ---------- */
  function drawerEl() { return document.getElementById('pm-drawer'); }

  function renderDrawer(s, eligible) {
    var dr = drawerEl();
    if (!dr || !cart) return;
    var itemsBox = $('[data-pm-dr-items]', dr);
    var ft = $('[data-pm-dr-ft]', dr);
    var prepaidView = hasPrepaid() && payment === 'prepaid';
    if (!cart.items.length) {
      var tpl = document.getElementById('pm-dr-empty-tpl');
      itemsBox.innerHTML = tpl ? tpl.innerHTML : '';
      ft.hidden = true;
      return;
    }
    var g = gifts(eligible);
    var h = '<ul class="pm-lines">';
    cart.items.forEach(function (it) {
      var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=128') + '" alt="" width="64" height="64" loading="lazy">' : '<span>' + esc(it.product_title) + '</span>';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var line = it.final_line_price;
      var off = prepaidView && line > 0 ? prepaidOff(it.final_price) * it.quantity : 0;
      var shown = line - off;
      var strike = off > 0 ? line : (it.original_line_price > line ? it.original_line_price : 0);
      h += '<li class="pm-line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">';
      h += '<a class="pm-sthumb" href="' + esc(it.url) + '">' + img + '</a>';
      h += '<div class="pm-ln-txt"><b><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></b>';
      if (variant) h += '<span class="pm-ln-var">' + esc(variant) + '</span>';
      if (line === 0) h += '<span class="pm-ln-gift pm-mono">Free gift</span>';
      h += '<div class="pm-qty"><button type="button" data-pm-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-pm-qty="1" aria-label="Increase quantity">+</button><button type="button" class="pm-rm" data-pm-qty="0">Remove</button></div></div>';
      h += '<div class="pm-ln-p"><b>' + rsP(shown) + '</b>' + (strike ? '<s>' + rsP(strike) + '</s>' : '') + '</div></li>';
    });
    h += '</ul>';
    if (C.tiers.length) {
      h += '<div class="pm-gifts-in"><span class="pm-kick pm-mono">Free gifts in this order · ' + g.count + '/' + g.total + '</span>';
      if (!g.count) h += '<p class="pm-dim">No gifts unlocked yet.</p>';
      else {
        h += '<ul>';
        g.unlocked.forEach(function (t) { h += '<li>' + giftThumb(t, 'done', true) + '<span>' + esc(t.name) + '</span><b class="pm-mono">FREE</b></li>'; });
        h += '</ul>';
      }
      if (g.next) h += '<p class="pm-next-gift">Next: <b>FREE ' + esc(g.next.name) + '</b> — add ' + rs(g.remaining) + ' more</p>';
      h += '</div>';
    }
    if (C.gold && eligible >= C.goldMin) {
      h += '<div class="pm-gold-note"><span class="pm-coin-dot" aria-hidden="true"></span><p><b>' + esc(C.goldNoteTitle || 'Eligible for the gold coin draw.') + '</b> ' + esc(C.goldNoteText || '') + (C.goldUrl ? ' <a href="' + esc(C.goldUrl) + '" data-pm-close>Rules &amp; T&amp;C</a>' : '') + '</p></div>';
    }
    itemsBox.innerHTML = h;

    // footer
    ft.hidden = false;
    var total = prepaidView ? s.p : s.m;
    var d = '';
    if (hasPrepaid()) {
      d += '<div class="pm-pay" role="radiogroup" aria-label="Payment estimate">';
      d += '<button type="button" role="radio" data-pm-pay="prepaid" aria-checked="' + (payment === 'prepaid') + '" class="' + (payment === 'prepaid' ? 'pm-on' : '') + '"><b>Pay online</b><span>UPI · Card · Netbanking</span><em>' + rs(s.p) + '</em></button>';
      d += '<button type="button" role="radio" data-pm-pay="cod" aria-checked="' + (payment === 'cod') + '" class="' + (payment === 'cod' ? 'pm-on' : '') + '"><b>Cash on delivery</b><span>Mahotsav price</span><em>' + rs(s.m) + '</em></button>';
      d += '</div>';
      if (payment === 'prepaid' && s.m > s.p) d += '<p class="pm-save-l">Prepaid saving: <b>' + rs(s.m - s.p) + '</b> vs Mahotsav price</p>';
      if (C.basis === 'final' && C.tiers.length) {
        var gp = gifts(s.ep).count, gm = gifts(s.em).count;
        if (gp < gm) d += '<p class="pm-warn">Paying online lowers your eligible subtotal to ' + rs(s.ep) + " — that's " + gp + ' ' + plural(gp, 'gift', 'gifts') + ' instead of ' + gm + '.</p>';
      }
    }
    d += '<div class="pm-dr-tot"><span>Subtotal' + (hasPrepaid() ? ' (est.)' : '') + '</span><b>' + rs(total) + '</b></div>';
    $('[data-pm-dr-dyn]', ft).innerHTML = d;
    var btnT = $('[data-pm-dr-btn-total]', ft);
    if (btnT) btnT.textContent = rs(total);
  }

  function openDrawer() {
    var dr = drawerEl();
    if (!dr) { window.location.href = C.cartUrl || '/cart'; return; }
    lastFocus = document.activeElement;
    dr.classList.add('pm-open');
    dr.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var x = $('.pm-x', dr); if (x) setTimeout(function () { x.focus(); }, 50);
    hideToast();
    fetchCart();
    track('cart_open', {});
  }
  function closeDrawer() {
    var dr = drawerEl();
    if (!dr || !dr.classList.contains('pm-open')) return;
    dr.classList.remove('pm-open');
    dr.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  PM.openCart = openDrawer;
  PM.closeCart = closeDrawer;

  /* ---------- sticky bar + header count ---------- */
  function renderSticky(s, eligible) {
    var bar = document.getElementById('pm-sticky');
    if (!bar) return;
    var count = cart ? cart.item_count : 0;
    var shopBtn = $('[data-pm-sticky-shop]', bar);
    var cartBox = $('[data-pm-sticky-cart]', bar);
    shopBtn.hidden = count > 0;
    cartBox.hidden = count === 0;
    if (count > 0) {
      var g = gifts(eligible);
      $('[data-pm-sc-total]', bar).textContent = rs(hasPrepaid() && payment === 'prepaid' ? s.p : s.m) + ' · ' + count + ' ' + plural(count, 'item', 'items');
      $('[data-pm-sc-next]', bar).textContent = !C.tiers.length ? '' : g.next ? rs(g.remaining) + ' to FREE ' + (g.next.short || g.next.name) : 'All ' + g.total + ' gifts unlocked';
      $('[data-pm-sc-bar]', bar).style.width = Math.min(100, (eligible / C.max) * 100) + '%';
      $('[data-pm-sc-gifts]', bar).textContent = g.count + '/' + g.total;
    }
    updateStickyVisibility();
  }
  function updateStickyVisibility() {
    var bar = document.getElementById('pm-sticky');
    if (!bar) return;
    var count = cart ? cart.item_count : 0;
    bar.classList.toggle('pm-show', window.scrollY > 520 || count > 0);
  }
  function headerCartLinks() {
    var url = C.cartUrl || '/cart';
    return $$('a[href="' + url + '"], a[href="' + url + '/"]').filter(function (a) { return !a.closest('.pm'); });
  }
  function renderHeaderCount() {
    if (!cart) return;
    headerCartLinks().forEach(function (a) {
      if (a.children.length) return;
      a.textContent = a.textContent.replace(/(\d+)(\)?\s*)$/, cart.item_count + '$2');
    });
  }

  /* ---------- render everything that depends on the cart ---------- */
  function renderAll() {
    var s = sums();
    var eligible = eligibleFrom(s);
    PM.eligible = eligible;
    $$('[data-pm-progress]').forEach(function (el) {
      el.innerHTML = progressHTML(eligible, el.getAttribute('data-pm-progress') === 'compact');
    });
    renderLadder(eligible);
    renderDrawer(s, eligible);
    renderSticky(s, eligible);
    renderHeaderCount();
    var gc = gifts(eligible).count;
    if (prevGiftCount !== null && gc > prevGiftCount) track('gift_unlocked', { tier: gc });
    prevGiftCount = gc;
  }

  /* ---------- cart API ---------- */
  function fetchCart() {
    return fetch((C.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderAll(); return c; })
      .catch(function () {});
  }
  function postJSON(url, body) {
    return fetch((C.root || '/') + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
        return j;
      });
    });
  }
  function addItems(items, label) {
    return postJSON('cart/add.js', { items: items }).then(function () {
      document.dispatchEvent(new CustomEvent('pm:cart-added'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return fetchCart();
    }).then(function () {
      var g = gifts(PM.eligible || 0);
      var sub = !C.tiers.length ? '' : g.next ? rs(g.remaining) + ' away from FREE ' + g.next.name : 'All ' + g.total + ' free gifts unlocked';
      showToast('<b>Added:</b> ' + esc(label), sub);
      track('add_to_cart', { items: items.map(function (i) { return String(i.id); }), label: label });
    });
  }
  function changeLine(key, qty, li) {
    if (li) li.classList.add('pm-busy');
    postJSON('cart/change.js', { id: key, quantity: qty }).then(function (c) {
      cart = c; renderAll();
    }).catch(function (e) {
      if (li) li.classList.remove('pm-busy');
      showToast(esc(e.message), '', true);
    });
  }

  /* ---------- toast ---------- */
  function showToast(html, sub, isErr) {
    var t = document.getElementById('pm-toast');
    if (!t) return;
    $('.pm-toast-txt', t).innerHTML = html;
    $('.pm-toast-sub', t).textContent = sub || '';
    $('.pm-toast-sub', t).hidden = !sub;
    t.classList.toggle('pm-err', !!isErr);
    t.hidden = false;
    t.style.animation = 'none'; void t.offsetWidth; t.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 3200);
  }
  function hideToast() { var t = document.getElementById('pm-toast'); if (t) t.hidden = true; }

  /* ---------- product cards ---------- */
  function cardData(card) {
    if (card.__pm) return card.__pm;
    var j = $('script[type="application/json"]', card);
    var data;
    try { data = JSON.parse(j.textContent); } catch (e) { return null; }
    var vid = parseInt(card.getAttribute('data-pm-vid'), 10);
    var v = data.variants.filter(function (x) { return x.id === vid; })[0] || data.variants[0];
    card.__pm = { data: data, sel: v ? v.o.slice() : [], v: v };
    return card.__pm;
  }
  function findVariant(data, sel) {
    return data.variants.filter(function (v) {
      for (var i = 0; i < sel.length; i++) if (v.o[i] !== sel[i]) return false;
      return true;
    })[0];
  }
  function pickOption(card, idx, val) {
    var st = cardData(card);
    if (!st) return;
    var sel = st.sel.slice();
    sel[idx] = val;
    var v = findVariant(st.data, sel);
    if (!v) {
      var cands = st.data.variants.filter(function (x) { return x.o[idx] === val; });
      v = cands.filter(function (x) { return x.a; })[0] || cands[0];
      if (v) sel = v.o.slice();
    }
    if (!v) return;
    st.sel = sel; st.v = v;
    refreshCard(card);
  }
  function refreshCard(card) {
    var st = cardData(card);
    if (!st || !st.v) return;
    var v = st.v, data = st.data;
    // option controls
    $$('[data-pm-opt]', card).forEach(function (ctl) {
      var i = parseInt(ctl.getAttribute('data-pm-opt'), 10);
      if (ctl.tagName === 'SELECT') {
        ctl.value = st.sel[i];
        $$('option', ctl).forEach(function (o) { o.disabled = false; });
      } else {
        $$('[data-pm-val]', ctl).forEach(function (b) {
          var val = b.getAttribute('data-pm-val');
          var on = val === st.sel[i];
          var test = st.sel.slice(); test[i] = val;
          var tv = findVariant(data, test);
          b.classList.toggle('pm-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.classList.toggle('pm-out', !tv || !tv.a);
        });
      }
    });
    var pre = PM.state === 'pre';
    var price = $('[data-pm-price]', card); if (price) price.textContent = rsP(v.p);
    var mrp = $('[data-pm-mrp]', card);
    if (mrp) { mrp.hidden = !(v.c > v.p); mrp.innerHTML = v.c > v.p ? 'MRP <s>' + rsP(v.c) + '</s>' : ''; }
    var off = $('[data-pm-off]', card);
    if (off) { off.hidden = !(v.c > v.p); off.textContent = v.c > v.p ? Math.round((v.c - v.p) * 100 / v.c) + '% off' : ''; }
    var ppw = $('[data-pm-prepaid]', card);
    if (ppw) { ppw.hidden = !hasPrepaid(); var pv = $('[data-pm-prepaid-val]', ppw); if (pv) pv.textContent = rsP(v.p - prepaidOff(v.p)); }
    var stock = $('[data-pm-stock]', card);
    if (stock) { stock.textContent = v.a ? (card.getAttribute('data-txt-in') || 'In stock') : (card.getAttribute('data-txt-out') || 'Sold out · pick another option'); stock.classList.toggle('pm-out', !v.a); }
    var btn = $('[data-pm-add]', card);
    if (btn && !btn.__busy) {
      btn.disabled = !v.a || pre;
      btn.textContent = pre ? (C.preBtn || 'Coming soon') : !v.a ? 'Sold out' : (card.getAttribute('data-txt-add') || 'Add to cart');
    }
    if (v.img && !card.hasAttribute('data-pm-custom-img')) {
      var img = $('.pm-card-img img', card);
      if (img && img.getAttribute('data-src-v') !== v.img) {
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = v.img; img.setAttribute('data-src-v', v.img);
      }
    }
    $$('a[data-pm-plink]', card).forEach(function (a) { a.href = data.url + (data.variants.length > 1 ? '?variant=' + v.id : ''); });
  }
  function initCards(root) {
    $$('[data-pm-card]', root).forEach(function (card) { cardData(card); refreshCard(card); });
  }

  /* ---------- stacks ---------- */
  function stackItems(stack) {
    return $$('[data-pm-stack-item]', stack).map(function (row) {
      var sel = $('select[data-pm-stack-sel]', row);
      var src = sel ? sel.options[sel.selectedIndex] : row;
      return {
        id: parseInt(src.getAttribute('data-vid') || (sel && sel.value), 10),
        price: parseInt(src.getAttribute('data-price'), 10) || 0,
        available: src.getAttribute('data-available') !== 'false',
        img: src.getAttribute('data-img'),
        row: row,
        title: row.getAttribute('data-title')
      };
    }).filter(function (x) { return x.id; });
  }
  function refreshStack(stack) {
    var items = stackItems(stack);
    var m = 0, p = 0, allOk = true;
    items.forEach(function (it) {
      m += it.price; p += it.price - prepaidOff(it.price);
      if (!it.available) allOk = false;
      if (it.img) { var im = $('.pm-sthumb img', it.row); if (im && im.getAttribute('src') !== it.img) { im.removeAttribute('srcset'); im.src = it.img; } }
    });
    m /= 100; p /= 100;
    var gm = gifts(m), gpp = gifts(p);
    $('[data-pm-stack-total]', stack).textContent = rs(m);
    var pre = $('[data-pm-stack-pre]', stack);
    if (pre) pre.textContent = hasPrepaid() ? ' · ' + rs(p) + ' prepaid*' : '';
    var h = '';
    if (C.tiers.length) {
      h += '<b>' + (gm.count ? 'This stack unlocks ' + gm.count + ' cumulative free ' + plural(gm.count, 'gift', 'gifts') : rs(gm.remaining) + ' short of the first gift') + '</b>';
      if (gm.count) h += '<span>' + gm.unlocked.map(function (t) { return esc(t.short || t.name); }).join(' · ') + '</span>';
      if (hasPrepaid() && C.basis === 'final' && gpp.count < gm.count) h += '<span class="pm-warn">Paying online (' + rs(p) + ') unlocks ' + gpp.count + ' ' + plural(gpp.count, 'gift', 'gifts') + '</span>';
    }
    if (C.gold && m >= C.goldMin) h += '<span class="pm-gold-line">' + esc(C.goldStackLine || 'Eligible for gold coin draw (separate promotion)') + '</span>';
    $('[data-pm-stack-gifts]', stack).innerHTML = h;
    var btn = $('[data-pm-stack-add]', stack);
    if (btn && !btn.__busy) {
      var preState = PM.state === 'pre';
      btn.disabled = preState || !allOk || !items.length;
      btn.textContent = preState ? (C.preBtn || 'Coming soon') : !allOk ? 'An item is sold out' : (stack.getAttribute('data-txt-add') || 'Add this stack →');
    }
  }
  function initStacks(root) { $$('[data-pm-stack]', root).forEach(refreshStack); }

  /* ---------- category filter ---------- */
  function filterCat(btn) {
    var shop = btn.closest('[data-pm-shop]');
    if (!shop) return;
    var cat = btn.getAttribute('data-pm-cat');
    $$('[data-pm-cat]', shop).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('pm-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-pm-card]', shop).forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(' ');
      card.hidden = !(cat === 'all' || cats.indexOf(cat) > -1);
    });
    var top = shop.getBoundingClientRect().top;
    if (top < 0) window.scrollTo({ top: window.scrollY + top - headOffset(), behavior: 'smooth' });
    btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    track('category', { c: cat });
  }

  /* ---------- countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function renderCountdowns() {
    $$('[data-pm-countdown]').forEach(function (el) {
      var st = PM.state;
      if (st === 'ended') { el.innerHTML = '<i></i>' + esc(el.getAttribute('data-ended') || 'Mahotsav has ended'); return; }
      var target = st === 'pre' ? C.startD : C.endD;
      var ms = Math.max(0, target - new Date());
      if (isNaN(ms)) ms = 0;
      var d = Math.floor(ms / 864e5); ms -= d * 864e5;
      var h = Math.floor(ms / 36e5); ms -= h * 36e5;
      var m = Math.floor(ms / 6e4);
      var lbl = st === 'pre' ? el.getAttribute('data-pre') : el.getAttribute('data-live');
      var suffix = st === 'pre' ? el.getAttribute('data-pre-suffix') || 'to go' : el.getAttribute('data-live-suffix') || 'left';
      el.innerHTML = '<i></i>' + esc(lbl || '') + ' <span class="pm-status-t">' + d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + esc(suffix) + '</span>';
    });
  }

  /* ---------- announcement rotation ---------- */
  var annTimer = null, annIdx = 0;
  function initAnnounce() {
    clearInterval(annTimer);
    var bar = $('[data-pm-ann]');
    if (!bar) return;
    function eligible() {
      return $$('.pm-ann-msg', bar).filter(function (m) {
        var show = m.getAttribute('data-show');
        if (show && show.split(' ').indexOf(PM.state) === -1) return false;
        if (m.hasAttribute('data-gold-only') && !C.gold) return false;
        return true;
      });
    }
    function show() {
      var list = eligible();
      $$('.pm-ann-msg', bar).forEach(function (m) { m.hidden = true; m.classList.remove('pm-in'); });
      bar.hidden = !list.length;
      if (!list.length) return;
      var m = list[annIdx % list.length];
      m.hidden = false; m.classList.add('pm-in');
    }
    show();
    var secs = parseInt(bar.getAttribute('data-rotate'), 10) || 7;
    annTimer = setInterval(function () { annIdx++; show(); }, secs * 1000);
    PM.refreshAnnounce = show;
  }

  /* ---------- sticky header offset ---------- */
  function headOffset() {
    var nav = $('#shopify-section-header .nav') || $('header .nav') || $('.nav');
    if (!nav || nav.closest('.pm')) return 0;
    var cs = getComputedStyle(nav);
    return cs.position === 'sticky' || cs.position === 'fixed' ? nav.getBoundingClientRect().height : 0;
  }
  function setHeadVar() { document.documentElement.style.setProperty('--pm-head', headOffset() + 'px'); }

  /* ---------- global events (bound once) ---------- */
  function bindGlobal() {
    if (PM.__bound) return;
    PM.__bound = true;

    document.addEventListener('click', function (e) {
      var t = e.target;
      var el;
      if ((el = t.closest('[data-pm-open-cart]'))) {
        // GoKwik mode: leave the click alone so GoKwik (or /cart) handles it.
        if (C.cartMode === 'drawer' && drawerEl()) { e.preventDefault(); openDrawer(); }
        else track('cart_open', { via: 'gokwik' });
        return;
      }
      if ((el = t.closest('[data-pm-close]'))) { closeDrawer(); if (el.tagName !== 'A') e.preventDefault(); return; }
      if ((el = t.closest('[data-pm-cat]'))) { e.preventDefault(); filterCat(el); return; }
      if ((el = t.closest('[data-pm-val]'))) {
        var grp = el.closest('[data-pm-opt]'), card = el.closest('[data-pm-card]');
        if (grp && card) { e.preventDefault(); pickOption(card, parseInt(grp.getAttribute('data-pm-opt'), 10), el.getAttribute('data-pm-val')); }
        return;
      }
      if ((el = t.closest('[data-pm-add]'))) {
        var c = el.closest('[data-pm-card]'), st = c && cardData(c);
        if (!st || !st.v || el.disabled) return;
        el.__busy = true; el.disabled = true; el.textContent = 'Adding…';
        var label = (c.getAttribute('data-title') || st.data.title) + (st.v.t && st.v.t !== 'Default Title' ? ' · ' + st.v.t : '');
        addItems([{ id: st.v.id, quantity: 1 }], label).then(function () {
          el.textContent = 'Added ✓';
          setTimeout(function () { el.__busy = false; refreshCard(c); }, 1400);
        }).catch(function (err) {
          el.__busy = false; refreshCard(c); showToast(esc(err.message), '', true);
        });
        return;
      }
      if ((el = t.closest('[data-pm-stack-add]'))) {
        var stack = el.closest('[data-pm-stack]');
        if (!stack || el.disabled) return;
        var items = stackItems(stack);
        el.__busy = true; el.disabled = true; el.textContent = 'Adding…';
        addItems(items.map(function (i) { return { id: i.id, quantity: 1 }; }), (stack.getAttribute('data-title') || 'Stack') + ' (' + items.length + ' items)').then(function () {
          el.textContent = 'Stack added ✓';
          setTimeout(function () { el.__busy = false; refreshStack(stack); }, 1400);
        }).catch(function (err) {
          el.__busy = false; refreshStack(stack); showToast(esc(err.message), '', true);
        });
        return;
      }
      if ((el = t.closest('[data-pm-yt]'))) {
        // Load the YouTube player only now, on tap.
        var vid = el.getAttribute('data-pm-yt');
        if (!/^[\w-]{6,20}$/.test(vid)) return;
        e.preventDefault();
        var f = document.createElement('iframe');
        f.className = 'pm-yt-frame';
        f.src = 'https://www.youtube-nocookie.com/embed/' + vid + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
        f.title = el.getAttribute('aria-label') || 'Video review';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        el.replaceWith(f);
        track('review_video_play', { id: vid });
        return;
      }
      if ((el = t.closest('[data-pm-qty]'))) {
        var li = el.closest('.pm-line');
        if (!li) return;
        var d = parseInt(el.getAttribute('data-pm-qty'), 10);
        var q = d === 0 ? 0 : Math.max(0, parseInt(li.getAttribute('data-qty'), 10) + d);
        changeLine(li.getAttribute('data-key'), q, li);
        return;
      }
      if ((el = t.closest('[data-pm-pay]'))) {
        payment = el.getAttribute('data-pm-pay');
        try { localStorage.setItem('pm-pay', payment); } catch (x) {}
        renderAll();
        return;
      }
      if (C.interceptHeader && (el = t.closest('a')) && !el.closest('.pm') && headerCartLinks().indexOf(el) > -1) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        openDrawer();
      }
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('select[data-pm-opt]')) {
        var card = t.closest('[data-pm-card]');
        if (card) pickOption(card, parseInt(t.getAttribute('data-pm-opt'), 10), t.value);
      } else if (t.matches('select[data-pm-stack-sel]')) {
        var stack = t.closest('[data-pm-stack]');
        if (stack) refreshStack(stack);
      }
    });

    document.addEventListener('submit', function (e) {
      if (e.target.closest && e.target.closest('#pm-drawer')) {
        var s = sums();
        track('checkout', { value: hasPrepaid() && payment === 'prepaid' ? s.p : s.m });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        var dr = drawerEl();
        if (!dr || !dr.classList.contains('pm-open')) return;
        var f = $$('a[href], button:not([disabled]), select, input', dr).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', setHeadVar);
    document.addEventListener('cart:updated', fetchCart);

    // live clock: flips pre → live → ended without a reload
    setInterval(function () {
      if (applyState()) refreshStateBound();
      renderCountdowns();
    }, 30000);

    // theme editor
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function () { setTimeout(function () { boot(document); }, 0); });
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest && e.target.closest('[data-pm-card]');
      if (card && card.hidden) { var all = $('[data-pm-cat="all"]', card.closest('[data-pm-shop]')); if (all) filterCat(all); }
    });
  }

  function refreshStateBound() {
    $$('[data-pm-card]').forEach(refreshCard);
    $$('[data-pm-stack]').forEach(refreshStack);
    if (PM.refreshAnnounce) PM.refreshAnnounce();
    renderAll();
  }

  /* ---------- boot ---------- */
  function boot(root) {
    if (!document.querySelector('.pm')) return;
    readConfig();
    applyState();
    setHeadVar();
    bindGlobal();
    initAnnounce();
    initCards(document);
    initStacks(document);
    renderCountdowns();
    renderAll();
    if (!PM.__viewed) { PM.__viewed = true; track('view', { state: PM.state, gold: !!C.gold }); }
    if (!cart || root !== document) fetchCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
})();
  } catch(e) { console.error(e); }
})();

})();
